import React, { Component } from 'react'
import App from './app'
import { BrowserRouter } from 'react-router-dom'
import { fetchBotConfig, fetchSyncedKnowledgebaseList } from 'modules/settings/actions'
import { fetchCategories } from 'modules/knowledgebase/actions'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

class AppContainer extends Component {
  componentDidMount() {
    this.props.fetchCategories()
    this.props.fetchBotConfig()
    this.props.fetchSyncedKnowledgebaseList()
  }
  
  render() {
    return (
      <BrowserRouter basename="help">
        <App/>
      </BrowserRouter>
    )
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    fetchBotConfig,
    fetchCategories,
    fetchSyncedKnowledgebaseList
  } , dispatch)
)

export default connect(null, mapDispatchToProps)(AppContainer)


